export default __webpack_public_path__ + "static/media/you-are-my-fave.b9061328.webp";